<template>
  <section
    id="wildcards"
    class="wild-card-section page-section qualifications qualifications__list online"
  >
    <a name="wildcards"></a>
    <div class="page-section__content">
      <div class="title text-uppercase">Wildcards</div>
      <div class="layout row wrap justify-center">
        <div
          class="flex xs12 sm6 md4"
          v-for="{ component, event } in wildcards"
          :key="event.id"
        >
          <component :is="component || 'WildCard'" :wildcard-event="event" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import WildCard from "./WildCard";
import StudentsWildCard from "./StudentsWildCard";

export default {
  name: "WildCardSection",
  components: {
    WildCard,
    StudentsWildCard
  },
  data() {
    return {
      wildcards: [
        {
          event: {
            id: 1,
            name: "Сеть клубов TrueGamers",
            place: "Все города",
            slots: 4,
            date: "7,14,21,28 февраля",
            bg: require("@/assets/img/wildcards/TrueGamers-bg.jpg"),
            logo: require("@/assets/img/wildcards/TrueGamers-logo.png"),
            href: "https://rbdota21.truegamers.ru/"
          }
        },
        {
          event: {
            id: 2,
            name: "META4PRO",
            place: "Ростов",
            slots: 1,
            date: "13 февраля",
            bg: require("@/assets/img/wildcards/Meta4pro-bg.jpg"),
            logo: require("@/assets/img/wildcards/Meta4pro-logo.png"),
            href: "https://vk.com/meta4pro?w=wall-189560169_2327"
          }
        },
        {
          event: {
            id: 3,
            name: "СПбФКС",
            place: "Санкт-Петербург",
            slots: 1,
            date: "28 февраля",
            bg: require("@/assets/img/wildcards/SPbFKS-bg.jpg"),
            logo: require("@/assets/img/wildcards/SPbFKS-logo.png"),
            href: " https://vk.com/spbfcs"
          }
        },
        {
          event: {
            id: 4,
            name: "Сеть клубов VAULT",
            place: "Казань",
            slots: 1,
            date: "21 февраля",
            bg: require("@/assets/img/wildcards/Kazan-bg.jpg"),
            logo: require("@/assets/img/wildcards/Vault-logo.png"),
            href: "https://vk.com/vault44"
          }
        },
        {
          event: {
            id: 5,
            name: "Olymp Arena",
            place: "Воронеж",
            slots: 1,
            date: "22-27 февраля",
            bg: require("@/assets/img/wildcards/Voronezh-bg.jpg"),
            logo: require("@/assets/img/wildcards/Olymp-logo.png"),
            href: "https://olymparena.club/#tournaments"
          }
        }
      ]
    };
  }
};
</script>

<style lang="scss">
.wild-card-section {
  .wild-card {
    height: 100%;
  }
}
</style>
